import moment from 'moment';

export default function getCurrentTimezoneOffset(){
    return moment().utcOffset();
}